
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Report_Adv04Grid extends Serenity.EntityGrid<Report_Adv04Row, any> {
        protected getColumnsKey() { return Report_Adv04Columns.columnsKey; }
        protected getDialogType() { return Report_Adv04Dialog; }
        protected getIdProperty() { return Report_Adv04Row.idProperty; }
        protected getInsertPermission() { return Report_Adv04Row.insertPermission; }
        protected getLocalTextPrefix() { return Report_Adv04Row.localTextPrefix; }
        protected getService() { return Report_Adv04Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)
        
            let descriptions: string[] = [];
            
            var a1n = ""
            let a1 : string= QRreport.QRywcSpecRow.getLookup().itemById["116"].PromoCampaign;
            if (a1 != null) {
                let pos = PsPromoCampaignRow.getLookup().itemById["116"].PromoCampaign;
                a1n = "  Campaign "  + pos
            } else {
                a1n = ""
            }

            var a2n = ""
            let a2 : string= QRreport.QRywcSpecRow.getLookup().itemById["116"].PmGroupId;
            if (a2 != null) {
                a2n = a1n +" กลุ่มโปรโมชั่น:" + a2 
            } else {
                a2n = ""
            }

            var x = ""
            let x1 : string= QRreport.QRywcSpecRow.getLookup().itemById["116"].ShopId;
            if (x1 != null) {
                //let pos = InitialData.PsShopTypeRow.getLookup().itemById[x1].ShopTypeName;
                x = a2n +" ร้านค้า:" + x1
            } else {
                x = ""
            }

            descriptions.push(x);
            
            return [descriptions, gridColumns];
        }

        protected createQuickSearchInput() {
        }
        
        protected getColumns() {
            var columns = super.getColumns();
        
            return columns;
        }
        
        protected usePager() {
            return false;
        }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
            groupingMixin.plugin.setDroppedGroups(["PromoCampaign"]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();
            
        }

        protected getButtons() {
            var buttons = super.getButtons();
        
            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
        
            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Report_Adv01Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
        
            let reportTitle = 'รายงาน-ยอดขายโปรฯ สรุปตามรหัสโปรฯ (Consolidated shop)'
        
            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "PromoCampaign", title: "Campaign", cellWidth: 30 },
                1: { field: "PmGroupId", title: "PmGroupId", cellWidth: 30 },
                2: { field: "PmId", title: "PmId.", cellWidth: 30},
                3: { field: "SalesQty", title: "Qty", cellWidth: 30,halign: 'right',aggregate:"sum"},
                4: { field: "SalesAmtBeforePromo", title: "ยอดขายก่อนลดโปร", cellWidth: 30,halign: 'right',aggregate:"sum"},
                5: { field: "PromoDisc", title: "ส่วนลดโปรฯ", cellWidth: 30,halign: 'right',aggregate:"sum"},
                6: { field: "SalesAmtAfterPromo", title: "ยอดขายหลังลดโปรฯ", cellWidth: 30,halign: 'right',aggregate:"sum"},
            }
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
        
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
        
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
        
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecAdvpro1004/edit/116';
                        return false;
                    },
                }
            );
        
            return buttons;
        }
    }
}